import apiClient from '../axios.js'

/**
 * 客戶月費計算 API
 */
export const clientMonthlyFeeService = {
    /**
     * 計算客戶月費
     * @param {string} clientId - 客戶 ID
     * @returns {Promise<Object>} 月費明細
     * @returns {number} planAmount - 方案基礎費用
     * @returns {number} optionalModulesAmount - 選購模組費用總和
     * @returns {number} totalAmount - 總費用
     * @returns {Array} optionalModulesDetail - 選購模組費用明細
     */
    calculateMonthlyFee: async (clientId) => {
        const response = await apiClient.get(`/system/clients/${clientId}/monthly-fee`)
        return response
    },
}













